import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBan } from '@fortawesome/free-solid-svg-icons'
import UserQuickActions from './UserQuickActions'

export default function UserMetadataCard({
  userInfo,
  age,
  onShowUserLobbies,
  onShowBankAccounts,
  onShowTransactions,
  onShowRatings,
  onShowChats,
  onShowWallet,
  walletBalances,
  onSendWhatsApp,
  onVerifyUser
}) {
  return (
    <div className='flex flex-col gap-3 border-[1px] border-gray rounded-lg p-6 grow w-full md:w-1/2 lg:w-[50%] justify-between dark:border-dk-border'>
      <p>
        <span className='font-bold'>Nombre: </span>{' '}
        {userInfo.blocked ? (
          <span className='text-error font-bold inline-flex items-center gap-1'>
            {userInfo.user_metadata.first_name}
            <FontAwesomeIcon icon={faBan} />
          </span>
        ) : (
          userInfo.user_metadata.first_name
        )}
      </p>
      <p>
        <span className='font-bold'>Apellido: </span>
        {userInfo.user_metadata.last_name}
      </p>
      <p>
        <span className='font-bold'>Edad: </span>
        {age} {age ? 'años' : ''}
      </p>
      <p>
        <span className='font-bold'>Género: </span>
        {userInfo.user_metadata.gender}
      </p>
      <p>
        <span className='font-bold'>Preferencias: </span>
        {userInfo.user_metadata.preferences?.join(' | ')}
      </p>
      <p>
        <span className='font-bold'>Biografía: </span>
        {userInfo.user_metadata.biography}
      </p>
      {userInfo.user_metadata.car && (
        <p>
          <span className='font-bold'>Auto: </span>
          {userInfo.user_metadata.car.model}, {userInfo.user_metadata.car.color}
        </p>
      )}
      <p>
        <span className='font-bold'>Ubicaciones preferidas: </span>
        {userInfo.user_metadata.preferred_locations?.map(x => x.location_name || x).join(' | ')}
      </p>
      <p>
        <span className='font-bold'>Frecuencia: </span>
        {userInfo.user_metadata.frequency}
      </p>
      {userInfo.user_metadata.potential_driver && (
        <p>
          <span className='font-bold'>Potencial conductor</span>
        </p>
      )}
      {userInfo.user_metadata.referral_user_id && (
        <p>
          <span className='font-bold'>Referido por: </span>
          {userInfo.user_metadata.referral_user_id}
        </p>
      )}
      <UserQuickActions
        onShowUserLobbies={onShowUserLobbies}
        onShowTransactions={onShowTransactions}
        onShowBankAccounts={onShowBankAccounts}
        onShowRatings={onShowRatings}
        onShowChats={onShowChats}
        onShowWallet={onShowWallet}
        walletBalances={walletBalances}
        onSendWhatsApp={onSendWhatsApp}
        hasBankAccounts={Boolean(
          userInfo.user_metadata.bank_accounts && userInfo.user_metadata.bank_accounts.length > 0
        )}
        isVerified={
          userInfo.user_metadata.verified === true || userInfo.user_metadata.verified === 'pending'
        }
        onVerifyUser={onVerifyUser}
      />
    </div>
  )
}
